<template>
  <div class="newsBody">
    <div class="newsInfo_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
        ><span @click="backtop" class="newsInfo_header_bread changeFont"
        >政策资讯</span
        ></el-breadcrumb-item
        >
        <el-breadcrumb-item
            :key="index"
            v-for="(item, index) in newsContentInfo.breadList"
        ><span
            class="changeFont"
            @click="backSec(index)"
            :class="!index ? 'secBreadcrumb' : ''"
        >{{ item }}</span
        ></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <el-skeleton v-if="loading" :rows="20" animated/>
    <div v-else class="newsInfo_warpper">
      <div class="erweima">
        <img
            :src="
            policyInformationList.length
              ? baseUrl + policyInformationList[0].imageUrl
              : ''
          "
            alt=""
        />
        <span>
          {{ policyInformationList.length ? policyInformationList[0].title : '' }}
        </span>
      </div>
      <div class="newsInfo_content">
        <div class="title">
          <div class="newsInfo_content_header">
            <div>
              <div
                  class="newsInfo_content_header_name"
                  v-if="newsInformation.titleFontSize"
                  :style="`font-size: ${newsInformation.titleFontSize}`"
              >
                {{ newsInformation.title }}
              </div>
              <div class="newsInfo_content_header_name" v-else>
                {{ newsInformation.title }}
              </div>
            </div>
            <div class="newsInfo_content_instraction1">
              <div class="newsInfo_content_instraction_left">
                <p>
                  <span>来源： {{ newsInformation.source }}</span>
                </p>
              </div>
              <div class="newsInfo_content_instraction_right">
                <p>
                  <span>发布时间：{{ newsInformation.gmtCreated }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="newsInfo_content_instraction">
          <div class="newsInfo_content_instraction_left">
            <p>
              <span>来源： {{ newsInformation.source }}</span>
            </p>
          </div>
          <div class="newsInfo_content_instraction_right">
            <p>
              <span>发布时间：{{ newsInformation.gmtCreated }}</span>
            </p>
          </div>
        </div>
        <div class="newsInfo_content_text" v-html="newsInformation.content"/>
        <div class="smallErweima">
          <img
              :src="
            policyInformationList.length
              ? baseUrl + policyInformationList[0].imageUrl
              : ''
          "
              alt=""
          />
          <span>
          {{ policyInformationList.length ? policyInformationList[0].title : '' }}
        </span>
        </div>
        <div class="fileUrl" v-if="newsInformation.fileUrl">
          <div>
            附件名：<span
              title="点击下载附件"
              @click="
                fileDownload(
                  getFileName(newsInformation.fileUrl),
                  newsInformation.filename,
                )
              "
              class="fileUrl_download"
          >{{ newsInformation.filename }}</span
          >
          </div>
        </div>
        <!-- 评论区域 -->
        <div class="comment-section" v-if="false">
          <h3 class="comment-title">评论</h3>
          <comment-component
              :newsId="newsInformation.id"
              v-if="this.$store.state.ordinaryUser"
          />
          <!-- 未登录提示 -->
          <div v-else class="login-tip">
            <p>登录后即可发表评论</p>
            <button class="login-btn" @click="handleLogin">立即登录</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommentComponent from '@/components/comments/CommentComponent.vue';
import {scrollTop} from '@/util/scrollTop';
import {getNewsInfo, downloadFile} from '@/API/news/news';
import {getHomeData} from '@/API/home/home';

export default {
  name: 'newContent',
  components: {
    CommentComponent,
  },
  props: {
    newsContentInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    newsContentInfo: {
      deep: true,
      immediate: true,
      handler: function (newValue) {
        this.getNewsInfoList(newValue.newsId);
      },
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      newsInformation: {},
      policyInformationList: [],
      loading: false,
    };
  },
  created() {
    this.getHomeData();
  },
  mounted() {
    scrollTop();
  },
  methods: {
    getNewsInfoList(id) {
      this.loading = true;
      getNewsInfo(id)
          .then((res) => {
            if (res.code === 200) {
              this.newsInformation = res.data;
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getFileName(fileUrl) {
      let name = fileUrl.split('/');
      return name[name.length - 1];
    },
    // 回到新闻中心首页
    backtop() {
      this.$emit('goParent', true);
    },
    // 点击面包屑去往查看更多页面
    backSec(index) {
      if (!index) {
        this.$emit('goSecond', this.newsContentInfo);
      }
    },
    handleLogin() {
      this.$store.commit('login/changeLoginDialogVisible', true);
    },
    fileDownload(fileUrl, filename) {
      downloadFile({filename: fileUrl}) // 确保请求配置 responseType: 'blob'
          .then((res) => {
            if (res) {
              // 创建 Blob 对象
              const blob = new Blob([res]);
              // 创建下载链接
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = filename || 'download.txt';
              document.body.appendChild(a);
              a.click();

              // 清理
              window.URL.revokeObjectURL(url);
              document.body.removeChild(a);
            } else {
              this.$message.error('下载失败：文件内容为空');
            }
          })
          .catch((error) => {
            this.$message.error('下载失败：' + error.message);
          });
    },
    getHomeData() {
      getHomeData('homePage').then((res) => {
        if (res.code == 200) {
          res.data.map((item) => {
            // 政策信息导流管理
            if (item.moduleKey === 'PolicyInformation') {
              this.policyInformationList = item.contents;
              console.log(
                  this.policyInformationList,
                  'this.policyInformationList',
              );
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .scroll{
    padding: 0 10px !important;
  }
  .newsBody {
    width: 100% !important;
    .newsInfo_content_header {
      padding: 0 !important;
      flex-direction: column !important;
    }
    .newsInfo_content {
      padding: 0 5px !important;
      /deep/ .newsInfo_content_text *{
        padding: 10px !important;
        font-size: 14px !important;
        font-weight: 100 !important;
      }
    }
    .changeFont {
      font-size: 14px !important;
    }
    .newsInfo_content_instraction1{
      display: block !important;
      text-align: center;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #606266;
    }
    .newsInfo_content_instraction{
      display: none !important;
    }
    .newsInfo_content_instraction_left{
      max-width: unset !important;
    }
    .newsInfo_content_header_name {
      width: 100% !important;
      font-size: 18px !important;
      font-weight: bold !important;
      display: -webkit-box !important;
      -webkit-box-orient: vertical !important;
      -webkit-line-clamp: 4 !important;
      line-clamp: 4 !important; /* 标准属性，兼容部分非webkit浏览器 */

      /* 基础：溢出隐藏+省略号 */
      overflow: hidden !important;
      text-overflow: ellipsis !important;

      /* 辅助：保证换行和排版 */
      word-break: break-all !important; /* 长单词/数字强制换行，避免撑破容器 */
      white-space: normal !important;   /* 取消单行强制，允许正常换行 */
      line-height: 1.5 !important;
    }
    .el-breadcrumb {
      line-height: unset !important;

      .el-breadcrumb__item {
        float: unset;
      }
    }

    .title {
      display: flex;
    }

    .smallErweima {
      padding:0 30px !important;
      width: 100% !important;
      display: block !important;
      display: flex !important;
      flex-direction: row;
      align-items: center;
      img{
        width: 100px !important;
        height: 100px !important;
      }
      span {
        display: inline-block;
        text-align: center;
        width: calc(100% - 100px);
        font-size: 14px;
      }

    }
    .newsInfo_content_text {
      margin-bottom: 0 !important;
    }

    .erweima {
      display: none !important;
    }
  }
}

.newsBody {
  width: 1200px;
  margin: 30px auto;

  .newsInfo_header {
    padding: 20px;

    .newsInfo_header_bread {
      color: #2c3e50;
      font-weight: 600;
      cursor: pointer;
    }

    .changeFont {
      font-size: 16px;
    }

    .newsInfo_header_bread:hover {
      color: #1290e5;
    }
  }

  .smallErweima {
    display: none;
  }
  .newsInfo_content_instraction1{
    display: none;
  }
  .newsInfo_warpper {
    display: flex;
    justify-content: center;
    height: 100%;
    width: inherit;
    margin-bottom: 100px;
    position: relative;

    .newsInfo_content {
      background: #ffffff;
      padding: 0 100px;
      width: inherit;

      .newsInfo_content_header {
        display: flex;
        justify-content: center;
        padding: 50px 100px 30px 100px;

        .newsInfo_content_header_name {
          width: 100%;
          text-align: center;
          font-size: 32px;
        }
      }


      .newsInfo_content_instraction {
        display: flex;
        justify-content: center;

        .newsInfo_content_instraction_left,
        .newsInfo_content_instraction_right {
          max-width: 250px;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #606266;
        }

        .newsInfo_content_instraction_left {
          margin-right: 20px;
        }
      }

      .newsInfo_content_text {
        padding: 0 100px;
        margin-top: 30px;
        margin-bottom: 100px;
        font-family: Hiragino Sans GB,
        MicroSoft YaHei;
        font-size: 16px; /* 16-18px 基础大小 */
        line-height: 1.6; /* 良好的行间距 */
        color: #333; /* 深灰色更易阅读 */
        text-align: justify; /* 两端对齐 */
        text-justify: inter-word; /* 单词间调整 */

        p {
          padding: 20px 0;
          text-indent: 2em;
          text-justify: inter-word; /* 单词间调整 */
        }
      }

      .fileUrl {
        margin: 20px 0;
        font-size: 16px;
        color: #636565;

        .fileUrl_download {
          text-decoration: underline;
          cursor: pointer;
        }

        .fileUrl_download:hover {
          color: #1da1f2;
        }
      }
    }
  }
}

.comment-section {
  border-top: 1px solid #eee;
  padding-top: 30px;
}

.comment-title {
  font-size: 20px;
  margin-bottom: 20px;
  color: #222;
}

.login-tip {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 4px;
  text-align: center;
  margin-bottom: 30px;
}

.login-tip p {
  margin-bottom: 15px;
  color: #666;
}

.login-btn {
  background: #1e88e5;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.3s;
}

.login-btn:hover {
  background: #1976d2;
}

.comment-box {
  margin-bottom: 30px;
}

.comment-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: none;
  font-family: inherit;
  font-size: 14px;
  margin-bottom: 10px;
  transition: border 0.3s;
}

.comment-textarea:focus {
  border-color: #1e88e5;
  outline: none;
}

.submit-btn {
  background: #1e88e5;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.submit-btn:hover {
  background: #1976d2;
}

.submit-btn:disabled {
  background: #b0bec5;
  cursor: not-allowed;
}

.secBreadcrumb {
  cursor: pointer;
  font-weight: 500;
}

.secBreadcrumb:hover {
  color: #1976d2;
}

.erweima {
  position: fixed;
  width: 100px;
  height: 165px;
  right: 12%;
  top: 20%;

  img {
    width: 100px;
    height: 100px;
  }

  span {
    display: inline-block;
    width: 100%;
    text-align: center;
  }
}
</style>
